export class ApplicationClaimStatus {
    code: string;
    name: string;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/models/applicationClaimStatus.ts